<template>
  <div class="p-3 pt-5 term-and-condition">
    <b-container>
      <b-row class="justify-content-end">
        <b-col xl="10" class="ml-auto mr-auto">
          <h3 class="text-center mb-4 fz-20">{{ $t("Privacy Policy") }}</h3>
          <p class="text-justify">
            Welcome to {{ companyName }}. These Terms and Conditions ("Terms") govern your use of our card solutions, services, and website. By accessing or using {{ companyName }} products or services, you agree to be bound by these Terms. Please read them carefully.
          </p>
          <div id="accordion">
            <section1 :companyName="companyName"/>
            <section2 :companyName="companyName"/>
            <section3 :companyName="companyName"/>
            <section4 :companyName="companyName"/>
            <section5 :companyName="companyName"/>
            <section6 :companyName="companyName"/>
            <section7 :companyName="companyName"/>
            <section8 :companyName="companyName"/>
            <section9 :companyName="companyName"/>
            <section10 :companyName="companyName"/>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import section1 from "@/components/termCondition/privacy/section1.vue";
import section2 from "@/components/termCondition/privacy/section2.vue";
import section3 from "@/components/termCondition/privacy/section3.vue";
import section4 from "@/components/termCondition/privacy/section4.vue";
import section5 from "@/components/termCondition/privacy/section5.vue";
import section6 from "@/components/termCondition/privacy/section6.vue";
import section7 from "@/components/termCondition/privacy/section7.vue";
import section8 from "@/components/termCondition/privacy/section8.vue";
import section9 from "@/components/termCondition/privacy/section9.vue";
import section10 from "@/components/termCondition/privacy/section10.vue";

export default {
  name: "privacy-policy",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      companyName: process.env.VUE_APP_COMPANY_NAME
    };
  },
  components: {
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
    section7,
    section8,
    section9,
    section10,
  },
  methods: {},
  mounted() {},
};
</script>
<style scoped>
ol,
ul,
li {
  font-size: 1rem;
  font-weight: 300;
  line-height: 2rem;
}
a {
  color: #5e72e4 !important;
  font-size: 1rem;
  font-weight: 300;
}
</style>
